
import { useEffect, useState } from "react";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import Paginator from "../../../common/paginator/Paginator";
import Webinar from "../common/webinar/Webinar";
import { ProfileEmpty, ProfileSection, ProfileSectionError } from "../common/ProfileSection";

export default function WebinarEnrollSection({ isDesktop }) {
	const [webinars, setWebinars] = useState([]);
	const [page, setPage] = useState(1);
	const [maxPageNum, setMaxPageNum] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		fetchWebinars();
	}, []);

	useEffect(() => {
		fetchWebinars();
	}, [page]);

	function fetchWebinars() {
		if (isLoading) {
			return;
		}
		setIsLoading(true);
		let pageParam = page ? page : 1;
		api.webinarListEnroll({
			token: LoginHelper.getToken(),
			page: pageParam,
		})
			.then((result) => {
				setWebinars(result["webinars"]);
				setMaxPageNum(result["max_page"]);
				setIsLoading(false);
			})
			.catch((err) => {
				setIsLoading(false);
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	}

	return (
		<ProfileSection title="وبینارهای ثبت‌نامی">
			{webinars.length >= 1 ? (
				<div className={`grid gap-4 ${isDesktop ? "grid-cols-3" : "grid-cols-1"}`}>
					{webinars.map((webinar) => (
						<Webinar key={webinar.id} webinar={webinar} />
					))}
				</div>
			) : (
				<ProfileEmpty>وبینار ثبت‌نامی وجود ندارد</ProfileEmpty>
			)}
			{webinars.length >= 1 && maxPageNum >= 2 && (
				<div className="flex justify-center mt-5">
					<Paginator
						currentPage={page}
						maxPageNum={maxPageNum}
						isLoading={isLoading}
						onChange={(newPage) => {
							setPage(newPage);
						}}
					/>
				</div>
			)}
			<ProfileSectionError message={errorMessage} />
		</ProfileSection>
	);
}
